<nav class="jadhu-nav" [class.scrolled]="scrolled">

  <div class="container-fluid px-3 px-lg-5">

    <div class="jadhu-nav-container">

      <!-- Logo -->
      <a routerLink="/" class="jadhu-brand" (click)="close()">
        <img src="images/logo.png" alt="Jadhu Logo" class="jadhu-brand-logo">
      </a>

      <!-- Desktop Navigation -->
      <ul class="jadhu-nav-links d-none d-xl-flex align-items-center gap-4 mb-0">

        @for (item of navItems; track item.route) {
        <li>

          <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{
                exact: item.exact ?? false
              }">
            {{ item.label }}
          </a>

        </li>
        }

      </ul>

      <!-- Right Actions -->
      <div class="jadhu-nav-actions">

        <!-- Language -->
        <div class="jadhu-lang-toggle">

          @for (language of languages; track language.code) {

          <span [class.active]="selectedLanguage === language.code" (click)="changeLanguage(language)"
            [attr.aria-label]="'Switch language to ' + language.label"
            [attr.aria-pressed]="selectedLanguage === language.code" role="button" tabindex="0">
            {{ language.label }}
          </span>

          }

        </div>

        <!-- Assessment -->
        <button type="button" routerLink="/pricing"
          class="btn-jadhu-rose jadhu-assessment-button d-none d-sm-inline-flex">

          Start free assessment
          <i class="bi bi-arrow-right ms-2"></i>
        </button>

        <!-- Mobile Toggle -->
        <button type="button" class="jadhu-hamburger d-xl-none" (click)="toggle()" [attr.aria-expanded]="mobileOpen"
          aria-label="Toggle navigation menu">
          <i class="bi" [class.bi-list]="!mobileOpen" [class.bi-x-lg]="mobileOpen"></i>
        </button>

      </div>

    </div>

  </div>

  <!-- Mobile Navigation -->
  <div class="jadhu-mobile-menu" [class.open]="mobileOpen">

    @for (item of navItems; track item.route) {

    <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{
          exact: item.exact ?? false
        }" (click)="close()">
      {{ item.label }}
    </a>

    }

    <!-- Mobile Assessment -->
    <button type="button" routerLink="/pricing" class="btn-jadhu-rose jadhu-mobile-button mt-2" (click)="close()">
      Start free assessment
      <i class="bi bi-arrow-right ms-2"></i>
    </button>

  </div>

</nav>
